import "./polyfill";
import { catchGlobalError } from "./global-error-detection";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import MoneyConnect from "./MoneyConnect";
import GTM from "./utils/gtm";
import { Select } from "antd";
import { jsonPretty } from "utils/common-util";

const setDefaultProps = () => {
  Select.defaultProps = {
    virtual: false,
  };
};

const initialApp = () => {
  console.json = (text) => console.log(jsonPretty(text));
};

initialApp();
catchGlobalError();
setDefaultProps();
GTM.initializeGTM();

ReactDOM.render(<MoneyConnect />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//copyright 2026 Krung Thai Bank Public Company Limited..
